

export const INTRO_SCREEN_DISPLAY_TIMEOUT = localStorage.getItem(
  "IntroScreenDisplayTimeout"
);

